// ========== 订单信息相关 ==========
import { getDefaultAddressId, getOrderPreview } from './orderInfo'

// ========== 地址相关 ==========
import { getCurrentAddress } from './address'

// ========== 订单操作相关 ==========
import orderAdd from './addOrder'
import payOrder from './payOrder'
import payAgain from './payAgain'

/**
 * 获取预支付信息
 * 自动获取并设置默认地址，然后获取订单预览
 */
const getPayOrderInfo = async ({ commit, state }, params) => {
  if (state.addressId === '') {
    const res = await getDefaultAddressId({ commit })
    
    if (res) {
      commit('SET_ADDRESSID', res)
    } else {
      return Promise.reject({
        msg: '请先选择地址',
        err_code: 'address_error'
      })
    }
  }

  const res = await getOrderPreview({ state, commit }, params)
  return res.data.data
}

/**
 * 创建订单
 */
const addOrder = async ({ commit, state }, params) => {
  return orderAdd({ commit, state }, params)
}

const actions = {
  // 订单信息
  getPayOrderInfo,
  
  // 订单操作
  addOrder,
  payOrder,
  payAgain,
  
  // 地址操作
  getCurrentAddress
}

export default actions
